// extracted by mini-css-extract-plugin
export default {"root":"_1d5ed-2SvxcQTdMhkL1h9T","stars":"_2tS05Urd8mpSQnYmi9Y8ld","border":"_2zbJgZOrxqC7gD4oRFSpPC"};